import { SVGAttributes } from "preact";

export default function VoiceIcon(props: SVGAttributes<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="11" y="2" width="2" height="20" rx="1" fill="currentColor"/>
            <rect x="6" y="8.25" width="2" height="7.5" rx="1" fill="currentColor"/>
            <rect x="21" y="9.5" width="2" height="5" rx="1" fill="currentColor"/>
            <rect x="1" y="9.5" width="2" height="5" rx="1" fill="currentColor"/>
            <rect x="16" y="5.75" width="2" height="12.5" rx="1" fill="currentColor"/>
        </svg>
    )
}